import config from 'config';

export const project = config.PROJECT;
